/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import AssignEngineersForm from './AssignEngineersForm/AssignEngineersForm';
import AssignEngineersSuccess from './AssignEngineersSuccess/AssignEngineersSuccess';
import AssignEngineersError from './AssignEngineersError/AssignEngineersError';
import Form from '../../../../../forms/_.extend';

import Loading from 'components/Loading/Loading';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  project: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'userStore')
@observer
export default class AssignEngineers extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const project: Object = this.props.project;

    const fields: Array<Object> = [
      {
        name: 'assignEngineers',
        label: t('general:actions.assign_project_to'),
        title: 'Assign Project To',
        fields: [
          {
            name: 'engineersIds',
            label: t('general:labels.assignee'),
            rules: 'required|array',
            value: [],
            placeholder: t('general:placeholders.first_last_name'),
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { engineersIds }: Object = data.values().assignEngineers;

        actionDrawerStore.assignEngineersToProject(project.id, {
          ids: engineersIds,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: t('general:actions.assign_project_to'),
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { project, actionDrawerStore, userStore }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.assign_engineers_to_project')} />
          <AssignEngineersError {...project} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.assign_engineers_to_project')} />
          <AssignEngineersSuccess {...project} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.assign_engineers_to_project')} />
        <AssignEngineersForm
          project={project}
          user={userStore.getActiveUserFromLocal()}
          form={this.createForm()}
        />
      </div>
    );
  }
}
